"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryOwnerPanelWithQueryClient = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactQuery = require("@tanstack/react-query");
var _RepositoryOwnerPanel = require("./RepositoryOwnerPanel");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var RepositoryOwnerPanelWithQueryClient = function RepositoryOwnerPanelWithQueryClient(_ref) {
  var onClose = _ref.onClose;
  var queryClient = new _reactQuery.QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3600000,
        // 1 hour = 3600000 milliseconds
        refetchOnWindowFocus: false
      }
    }
  });
  return /*#__PURE__*/React.createElement(_reactQuery.QueryClientProvider, {
    client: queryClient,
    contextSharing: true
  }, /*#__PURE__*/React.createElement(_RepositoryOwnerPanel.RepositoryOwnerPanel, {
    onClose: onClose
  }));
};
exports.RepositoryOwnerPanelWithQueryClient = RepositoryOwnerPanelWithQueryClient;